import { Paper, Typography } from "@mui/material";
import { FC } from "react";
import TableView from "./TableView";
import { VerificationProvider } from "../context/VerificationContext";

const Content: FC = () => {
      
  return (
    <div className="p-2 flex flex-col gap-3">
      <div className="py-2 border-b-2 flex justify-between items-center">
        <Typography
          variant="h6"
          fontSize={".8rem"}
          fontWeight={"600"}
          sx={{ color: "primary.main" }}
        >
          INSURANCE VERIFICATION
        </Typography>
      </div>
       <Paper>
       <TableView />
       </Paper>
    </div>
  );
};

const Verification: FC = () => {
  return (
    <VerificationProvider>
      <Content />
    </VerificationProvider>
  );
};

export default Verification;
